// Weather Parser Utility
import { feelsLikeTemp } from './feelsLike';

export const parseWeatherData = (weatherJson) => {
  const {
    temperature,
    humidity,
    windSpeed,
    condition,
    heatIndex,
    windChill,
    dewPoint,
    cloudCover,
    rainChance,
    uvIndex,
    // Today's real extremes, measured by the same station (backend derives
    // them from the AWS aggregate-day feed). Older backends omit them, so the
    // current reading stands in rather than rendering an empty panel.
    tempHigh,
    tempLow
  } = weatherJson;

  let description = '';
  let tempDesc = '';
  let humidityDesc = '';
  let windDesc = '';
  let skyDesc = '';

  // Temperature description (apparent temperature — see feelsLike.js).
  // Calibrated for Islamabad/Punjab summers, where 40°C+ is routine — so a
  // 26-28°C day with cloud cover reads as "Pleasant", not "Hot" (2026-07-21:
  // F-11 was reporting heat index 28.2°C and this bucket called it "Hot").
  const effectiveTemp = feelsLikeTemp(weatherJson) ?? temperature;
  if (effectiveTemp < 10) tempDesc = 'Cold';
  else if (effectiveTemp < 18) tempDesc = 'Cool';
  else if (effectiveTemp < 24) tempDesc = 'Mild';
  else if (effectiveTemp < 30) tempDesc = 'Pleasant';
  else if (effectiveTemp < 36) tempDesc = 'Warm';
  else if (effectiveTemp < 42) tempDesc = 'Hot';
  else tempDesc = 'Very hot';

  // Humidity description. Monsoon-season Islamabad regularly sits in the
  // 80-85% band without feeling oppressive, so "very humid" is reserved for
  // readings clearly above that.
  if (humidity < 30) humidityDesc = 'dry';
  else if (humidity < 65) humidityDesc = 'comfortable';
  else if (humidity < 85) humidityDesc = 'humid';
  else humidityDesc = 'very humid';

  // Wind description
  if (windSpeed < 5) windDesc = 'calm';
  else if (windSpeed < 15) windDesc = 'light winds';
  else if (windSpeed < 30) windDesc = 'moderate winds';
  else windDesc = 'strong winds';

  // Sky description
  if (cloudCover < 20) skyDesc = 'clear skies';
  else if (cloudCover < 50) skyDesc = 'partly cloudy';
  else if (cloudCover < 80) skyDesc = 'mostly cloudy';
  else skyDesc = 'overcast';

  description = `${tempDesc} and ${humidityDesc} with ${windDesc} and ${skyDesc}`;

  // Add rain mention if high chance
  if (rainChance > 50) {
    description += `. High chance of rain`;
  }

  return {
    description,
    temperature,
    humidity,
    windSpeed,
    condition,
    heatIndex,
    windChill,
    dewPoint,
    cloudCover,
    rainChance,
    uvIndex,
    tempHigh: Number.isFinite(tempHigh) ? tempHigh : temperature,
    tempLow: Number.isFinite(tempLow) ? tempLow : temperature
  };
};
